import { Box } from "../../../../components";
import { formatPrice } from "../../../../utils";

function MonitorFatRankingBarra({
  itens = [],
  corBarra = "#1976d2",
  formatarValor = (valor) => formatPrice(valor),
}) {
  const total = itens.reduce((acc, cur) => acc + cur.valor, 0);
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      {itens.map((item, i) => {
        const percentual = total > 0 ? (item.valor / total) * 100 : 0;

        return (
          <Box
            key={item.key}
            width="100%"
            className="d-flex align-items-center gap-2"
          >
            <Box
              sx={{
                width: 24,
                height: 24,
                borderRadius: "50%",
                mx: "auto",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 12,
                fontWeight: 700,
                color: i < 3 ? "#fff" : "#475569",
                backgroundColor:
                  i < 3 ? ["#FFD700", "#C0C0C0", "#CD7F32"][i] : "#e2e8f0",
              }}
            >
              {i + 1}
            </Box>
            <Box flex="1">
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mb={0.75}
              >
                <Box
                  sx={{
                    fontSize: 14,
                    fontWeight: 500,
                    color: "#333",
                  }}
                >
                  {item.label}
                </Box>

                <Box
                  display="flex"
                  alignItems="center"
                  gap={1}
                  sx={{ fontSize: 13 }}
                >
                  <Box sx={{ color: "#666" }}>{formatarValor(item.valor)}</Box>

                  <Box
                    sx={{
                      fontWeight: 600,
                      color: "#3f51b5",
                      minWidth: 48,
                      textAlign: "right",
                    }}
                  >
                    {percentual.toFixed(1)}%
                  </Box>
                </Box>
              </Box>

              <Box
                sx={{
                  backgroundColor: "#eeeeee",
                  borderRadius: 5,
                  width: "100%",
                  height: 8,
                  overflow: "hidden",
                }}
              >
                <Box
                  sx={{
                    width: `${Math.min(percentual, 100)}%`,
                    height: "100%",
                    backgroundColor: corBarra,
                    borderRadius: 5,
                    transition: "width 0.4s ease",
                  }}
                />
              </Box>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
}

export default MonitorFatRankingBarra;
